"use client";

import localStorageCall from '@/services/Methods/localstorage.hook';
import { useParams, usePathname, useRouter, useSearchParams, useSelectedLayoutSegment, useSelectedLayoutSegments, notFound, redirect } from 'next/navigation';
import { useState } from 'react';

function withRouteHOC(Component) {

    const WithRouteHOCComponent = (props) => {
        const [selectedBrandType, setSelectedBrandType] = useState(0)
        let router = useRouter();
        const searchParams = useSearchParams();
        const segment = useSelectedLayoutSegment();
        const pathname = usePathname();
        const segments = useSelectedLayoutSegments();
        let isUserLogin = localStorageCall().getSingleItem('Token');
        let params = useParams();

        return <Component {...props} {...{
            router, params,
            searchParams,
            isUserLogin, segment, redirect,
            segments, pathname, notFound, setSelectedBrandType, selectedBrandType
        }} />
    }

    return WithRouteHOCComponent;
}

export default withRouteHOC;